import { AreaChart, Area, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { CHART_GRID_COLOR, CHART_AXIS_TICK_STYLE } from './chartPalette';
import { CustomChartTooltip } from './CustomChartTooltip';
import { ChartCard } from '@/components/ui/chart-card';

interface Week {
  weekStartDate: string;
  contestantReach: number;
  titleholderReach: number;
}

/**
 * ProgramReachStackedArea — re-skinned for PR (m.8) Phase 2 onto
 * the canonical `<ChartCard>` chrome. The chart body remains
 * unchanged; the legacy hand-rolled `bg-white border-gold-100`
 * shell is replaced with the shared primitive.
 */
export function ProgramReachStackedArea({ weeks }: { weeks: Week[] }) {
  if (!weeks || weeks.length === 0) {
    return (
      <ChartCard eyebrow="Total Program Reach" title="Over Season">
        <div className="py-6 text-center text-eyebrow-sm text-muted-foreground">
          No data yet
        </div>
      </ChartCard>
    );
  }
  return (
    <ChartCard eyebrow="Total Program Reach" title="Over Season">
      <div style={{ width: '100%', height: 280 }}>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={weeks} margin={{ top: 8, right: 16, left: 8, bottom: 8 }}>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR} />
            <XAxis dataKey="weekStartDate" tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} />
            <YAxis tick={CHART_AXIS_TICK_STYLE} stroke={CHART_GRID_COLOR} />
            <Tooltip content={<CustomChartTooltip />} />
            <Area type="monotone" dataKey="contestantReach" name="Contestants" stackId="reach" stroke="#3d2f0b" fill="#3d2f0b" isAnimationActive={false} />
            <Area type="monotone" dataKey="titleholderReach" name="Titleholders" stackId="reach" stroke="#a48b3c" fill="#a48b3c" isAnimationActive={false} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </ChartCard>
  );
}
